<template>
  <FloorPlannerIframe
    :art_nr="resolveQuery(route.query.art_nr) ?? ''"
    :art_name="resolveQuery(route.query.art_name) ?? ''"
    :design="resolveQuery(route.query.design)"
    :surface="resolveQuery(route.query.surface)"
    :construction="resolveQuery(route.query.construction)"
  />
</template>

<script setup lang="ts">
const { $t } = useNuxtApp();
const route = useRoute();

const resolveQuery = (val: string | null | (string | null)[] | undefined): string | null => {
  if (Array.isArray(val)) return val.at(0) ?? null;
  return val ?? null;
};

useHead({
  title: $t('floorPlanner.headline2'),
});
</script>
